import React from 'react';
import {
  Box, CircularProgress,
  Container,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import HeaderNavigator from '../../../components/HeaderNavigator';
import useNavigate from '../../../hooks/useNavigate';
import STRING_KEYS from '../../../language/keys';
import style from './style';

type PositionContainerType = {
  children: JSX.Element | JSX.Element[];
  isLoading: boolean,
}

const { main, loader, container } = style;

export default function PositionDetailsContainer({
  children, isLoading,
}: PositionContainerType): JSX.Element {
  const { t: translate } = useTranslation();
  const { goToPositions } = useNavigate();
  const navElements = [{
    title: translate(STRING_KEYS.POSITIONS_PAGE_TITLE),
    onClick: goToPositions,
  }, {
    title: translate(STRING_KEYS.POSITIONS_DETAILS_PAGE_TITLE_NAV),
    current: true,
  }];
  const renderLoader = () => (
    <Box sx={ loader.sx }>
      <CircularProgress />
    </Box>
  );

  return (
    <Box
      component="main"
      sx={ main.sx }
    >
      <Container maxWidth={ container.maxWidth }>
        <HeaderNavigator elements={ navElements } />
        { isLoading ? renderLoader() : children }
      </Container>
    </Box>
  );
}
